import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Text,
  Flex,
  ModalCloseButton,
  Spinner,
  ModalBody,
  ModalFooter,
  Button,
} from '@chakra-ui/react';
import { samplesApi } from '@texas/api/endpoints/samplesApi';
import { useApiRequest } from '@texas/api/hooks/useApiRequest';
import { useApiResource } from '@texas/api/hooks/useApiResource';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorDetails } from '../alert/ErrorDetails';
import { SharedDisclosureProps } from '../types';
import { request } from '@texas/utils/helpers/httpHelpers';
import { transportRequestsApi } from '@texas/api/endpoints/transportRequestApi';
import { SamplesTable } from '../samples/SamplesTable';

interface Props extends SharedDisclosureProps {
  sampleIds: number[];
  onPerformed: () => void;
}

export function RemoveSamplesFromTransportRequestModal(props: Props) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Flex gap={2} align="center">
            <Text>{t('sample.removeFromTransportRequest')}</Text>
          </Flex>
        </ModalHeader>
        <ModalCloseButton />
        <Inner
          sampleIds={props.sampleIds}
          onPerform={() => {
            props.onPerformed();
            props.onClose();
          }}
        />
      </ModalContent>
    </Modal>
  );
}

function Inner({
  sampleIds,
  onPerform,
}: {
  sampleIds: number[];
  onPerform: () => void;
}) {
  const { t } = useTranslation();

  const {
    data: samples,
    refetch: refetchSamples,
    loading: samplesLoading,
    error,
  } = useApiResource(samplesApi.fromIds);

  const {
    request: mainReq,
    loading: mainReqLoading,
    error: mainReqError,
  } = useApiRequest(transportRequestsApi.removeSamples);

  useEffect(() => {
    refetchSamples(sampleIds);
  }, [refetchSamples, sampleIds]);

  const req = () => request(mainReq, [{ sampleIds }], () => onPerform());

  return (
    <>
      <ModalBody>
        <Flex flexDir="column" gap={2} w="full">
          {error && <ErrorDetails error={error} />}
          {mainReqError && <ErrorDetails error={mainReqError} />}
          {samplesLoading && <Spinner />}
          <SamplesTable samples={samples ?? []} />
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Button
          isLoading={mainReqLoading}
          disabled={mainReqLoading}
          onClick={() => req()}
        >
          {t('sample.removeFromTransportRequest')}
        </Button>
      </ModalFooter>
    </>
  );
}
